export default __webpack_public_path__ + "static/media/icon-jonopp.8593a8f2.svg";